import React from 'react';
import { TouchableOpacity, View, Text, Image, StyleSheet } from 'react-native';
import { ms, s, vs } from '../utils/responsive';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { RootStackParamList } from '../types/navigation';

import { createLogger } from '../utils/logger';
const logger = createLogger('CategoryCard');

interface CategoryCardProps {
  item: {
    id: string;
    name: string;
    icon: any;
    count: number;
    totalTasks: number;
  };
  isSelected: boolean;
  navigation: NativeStackNavigationProp<RootStackParamList>;
  onPress: (id: string) => void;
}

export const CategoryCard: React.FC<CategoryCardProps> = ({ item, isSelected, navigation, onPress }) => {
  // Debug log for props
  logger.debug('CategoryCard item:', item);
  const handleCardPress = () => {
    onPress(item.id);
    switch (item.id) {
      case 'all':
        navigation.navigate('Dashboard', { screen: 'AllTasks' });
        break;
      case 'personal':
        navigation.navigate('Dashboard', { screen: 'PersonalChecklist' });
        break;
      case 'medical':
        navigation.navigate('Dashboard', { screen: 'MedicalChecklist' });
        break;
      case 'finance':
        navigation.navigate('Dashboard', { screen: 'FinanceChecklist' });
        break;
      case 'property':
        navigation.navigate('Dashboard', { screen: 'PropertyChecklist' });
        break;
      case 'finalWishes':
        navigation.navigate('Dashboard', { screen: 'FinalWishesChecklist' });
        break;
      case 'finalCare':
        navigation.navigate('Dashboard', { screen: 'FinalCareChecklist' });
        break;
      case 'healthcareDirectives':
        navigation.navigate('Dashboard', { screen: 'HealthcareDirectivesChecklist' });
        break;
      case 'estatePlanning':
        navigation.navigate('Dashboard', { screen: 'EstatePlanningChecklist' });
        break;
      case 'carePreferences':
        navigation.navigate('Dashboard', { screen: 'CarePreferencesChecklist' });
        break;
      case 'passwords':
        navigation.navigate('Dashboard', { screen: 'OnlineAccountsChecklist' });
        break;
      case 'contacts':
        navigation.navigate('Dashboard', { screen: 'EmergencyContactsChecklist' });
        break;
      case 'expenses':
        navigation.navigate('Dashboard', { screen: 'ExpensesChecklist' });
        break;
      case 'documents':
        navigation.navigate('Dashboard', { screen: 'DocumentManagementChecklist' });
        break;
      case 'loyaltyPoints':
        navigation.navigate('Dashboard', { screen: 'LoyaltyPointsChecklist' });
        break;
    }
  };

  const progressText = item.totalTasks > 0
    ? `${item.count} of ${item.totalTasks} tasks completed`
    : '';

  return (
    <TouchableOpacity
      style={[
        styles.categoryCard,
        { backgroundColor: isSelected ? '#29BFC0' : '#FFFFFF' }
      ]}
      onPress={handleCardPress}
      accessibilityRole="button"
      accessibilityLabel={`${item.name} category. ${progressText}`}
      accessibilityHint={`Double tap to view ${item.name} tasks`}
      accessibilityState={{ selected: isSelected }}
    >
      <View
        style={styles.categoryIconContainer}
        accessibilityElementsHidden={true}
      >
        <Image source={item.icon} style={[styles.categoryIcon, { tintColor: '#29BFC0' }]} />
      </View>
      <Text style={[
        styles.categoryName,
        { color: isSelected ? '#FFFFFF' : '#1C2C4F' }
      ]}>{item.name}</Text>
      {item.totalTasks > 0 ? (
        <>
          <Text style={[
            styles.categoryCount,
            { color: isSelected ? '#FFFFFF' : '#6B7280' }
          ]}>{item.count} of {item.totalTasks} tasks</Text>
          <Text style={styles.completedText}>Completed</Text>
        </>
      ) : null}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  categoryCard: {
    width: ms(130, 0.3),
    height: ms(150, 0.3),
    borderRadius: ms(20),
    marginRight: ms(15),
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    padding: ms(10),
  },
  categoryIconContainer: {
    width: ms(50, 0.3),
    height: ms(50, 0.3),
    borderRadius: ms(25),
    backgroundColor: '#F3F6F8',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: ms(10),
  },
  categoryIcon: {
    width: ms(32, 0.3),
    height: ms(32, 0.3),
    resizeMode: 'contain',


  },
  categoryName: {
    fontSize: ms(16, 0.3),
    fontWeight: '600',
    marginBottom: ms(4),
    textAlign: 'center',
  },
  categoryCount: {
    fontSize: ms(14, 0.3),
    fontWeight: '400',
    marginBottom: ms(8),
  },
  completedText: {
    fontSize: ms(14, 0.3),
    color: '#F2994A',
    textAlign: 'center',
    marginTop: ms(-2),
  },
});
